import React from "react";
import { AudioIcon, VideoIcon } from "./icons";

/*
 * Media-availability indicator (Latest Classes reference) — the one new
 * element that page introduces: a 44px tile + 11px caps label. audio/video
 * render the standard gray tile; a class with BOTH gets the Royal Blue
 * combined tile ("A + V"). Purely informational (aria-hidden tile, text
 * label carries the meaning) — never color alone.
 */

export default function MediaIndicator({ media }) {
  const both = media === "both";
  const label = both ? "A + V" : media === "video" ? "Video" : "Audio";
  return (
    <span className="flex-shrink-0 flex flex-col items-center gap-[3px] w-[52px]">
      <span
        aria-hidden="true"
        className={
          both
            ? "w-11 h-11 border border-ic-blue bg-[rgba(24,108,206,0.06)] rounded-2xl inline-flex items-center justify-center gap-0.5 text-ic-blue"
            : "w-11 h-11 border border-ic-borderGray rounded-2xl inline-flex items-center justify-center text-ic-body"
        }
      >
        {both ? (
          <>
            <VideoIcon size={17} />
            <AudioIcon size={15} />
          </>
        ) : media === "video" ? (
          <VideoIcon size={22} />
        ) : (
          <AudioIcon size={22} />
        )}
      </span>
      <span
        className={`text-[11px] font-bold tracking-[0.3px] leading-[14px] uppercase ${both ? "text-ic-blue" : "text-ic-slate"}`}
      >
        {label}
      </span>
    </span>
  );
}
